import { Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { highlightStyles, wordBreak } from 'app/domains/global-search/components/styled';
export const StyledText = styled(Typography) `
  display: block;
  line-height: 1.4;
  ${wordBreak}

  mark {
    ${highlightStyles}
  }
`;
